/** Motion presets mapped to common UI intent. */

import { DURATION, SPRING, STAGGER_DELAY } from './animation';

export const MOTION = {
  /** Entrance presets. */
  entrance: {
    /** Attention-grabbing entrance. */
    emphasis: {
      type: 'scale' as const,
      duration: DURATION.normal,
      initialScale: 0.95,
    },
    /** Default content entrance. */
    standard: {
      type: 'fadeUp' as const,
      duration: DURATION.normal,
      distance: 8,
    },
    /** Subtle supporting-content entrance. */
    subtle: {
      type: 'fade' as const,
      duration: DURATION.fast,
    },
    /** Sequenced list-item entrance. */
    sequential: {
      type: 'fadeUp' as const,
      duration: DURATION.normal,
      distance: 6,
    },
  },

  /** Stagger timing presets. */
  stagger: {
    /** Default stagger interval. */
    standard: {
      staggerDelay: 80,
    },
    /** Slower stagger interval. */
    slow: {
      staggerDelay: STAGGER_DELAY,
    },
  },
  /** Interactive state presets (hover / active / press). Tailwind class fragments. */
  interactive: {
    /** Primary CTA — shadow lift on hover, color shift on active. No scale. */
    btnPrimary: {
      base: 'shadow-hard-1 web:transition-all web:duration-150',
      hover: 'data-[hover=true]:shadow-hard-2',
      active: 'data-[active=true]:shadow-none',
    },
    /** Text link — color + underline shift only, no scale. */
    btnLink: {
      base: 'web:transition-colors web:duration-150',
    },
    /** Text style for link buttons — underline by default, removed on hover. */
    linkText: {
      base: 'underline',
      hover: 'data-[hover=true]:no-underline',
    },
  },

  /** Press animation configs for usePressAnimation hook. */
  press: {
    /** Standard button press-down. */
    standard: { pressedScale: 0.985, spring: SPRING.snappy },
    /** Gentle press for secondary actions. */
    gentle: { pressedScale: 0.99, spring: SPRING.gentle },
  },
} as const;
